import axios from "axios";
import API from "../_helpers/endpointService";

export const getlookupdocinfo = (data) => {
  let apiUrl = API.LOOKUP_DATA + '/type?type=' + data;
  return (dispatch) => {
     dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
         dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "LOOKUP_DATAS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const getlookuppageinfo = (data, type) => {
  let apiUrl = API.LOOKUP_DATA + '?Name=' + data.Name + '&Type=' + type + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
  return (dispatch) => {
    // dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        // dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          //   response.data.Values.push({
          //     Id: 0,
          //     Name: '',
          //     Description: ''
          // })
          response?.data?.Values.sort((a, b) => {
            return a.Id - b.Id;
          })
          dispatch({type: "LOOKUP_DATAS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        // dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
